<app-view [name]="'contact'" (search)="onSearch($event)"></app-view>

<ng-container *ngIf="ready">
  <div class="butonera">
    <button type="button" (click)="create()" mat-stroked-button class="btn btn-warning btn-circle btn-lg fc-black p-0"
      style="display: inline-block;">
      <mat-icon class="mat-icon-add-custom">add</mat-icon>
      <app-help key='Contactos4'></app-help>
    </button>

    <button mat-stroked-button (click)="report347()">Informe 347</button>
    <button class="ms-2" mat-stroked-button (click)="import()">Importar</button>
    <app-help key='Contactos1'></app-help>
    <button class="ms-2" mat-stroked-button (click)="export()">Exportar</button>
    <app-help key='Contactos2'></app-help>
  </div>
</ng-container>

<app-table [columns]="headerTable" [dataSource]="dataSource" [hasButton]="true" [actionsTemplate]="actionsButtons"
  [hasObservableFilter]="false" [hasFilterOldObservable]="false" [remarkField]="'arrendador'"
  [remarkMessage]="'incompleteMessage'" (nameConceptClick)="onCompanyNameClick($event)"
  (entranceAccountClientClick)="onEntranceAccountClientClick($event)"
  (entranceAccountProviderClick)="onEntranceAccountProviderClick($event)">
</app-table>

<div class="container-fluid">
  <div class="row">
    <div class="col-md-2 col-lg-1 col-xs-12">
      <select id="itemsPerPage" [(ngModel)]="itemsPerPage" (change)="getList()" class="form-control"
        style="margin-left: 20px;">
        <option value="5">5</option>
        <option value="10">10</option>
        <option value="20">20</option>
      </select>
    </div>
    <div class="col-md-10 col-lg-11 col-xs-12">
      <pagination (pageChanged)="pageChanged($event)" [(ngModel)]="currentPage" [totalItems]="totalItems"
        [itemsPerPage]="itemsPerPage" [maxSize]="5" previousText="Anterior" style="float: right;margin-right: 20px;"
        nextText="Siguiente"></pagination>
    </div>
  </div>
</div>

<ng-container *ngIf="empty">
  <div class="text-center">
    <img src="assets/icons/contacto.svg" class="invoiceImage">
    <p style="color: #9e9e9e">No tiene ningún contacto, presione + para crear uo.</p>
  </div>
</ng-container>

<ng-template #actionsButtons let-uid="uid">
  <ul class="custom-class">
    <li (click)="edit(uid)">
      <a>
        <mat-icon>create</mat-icon>Editar
      </a> <app-help key='Contactos5'></app-help>
    </li>
    <li (click)="delete(uid)">
      <a>
        <mat-icon>warning</mat-icon>Borrar
      </a>
    </li>
    <li (click)="openContactT(uid)">
      <a>
        <mat-icon>person</mat-icon> Histórico
      </a>
    </li>
    <li (click)="syncBookcit(uid)">
      <a>
        <mat-icon>sync</mat-icon> Sincronizar con Bookcit
      </a>
    </li>
    <li (click)="extractoContable(uid)">
      <a>
        <mat-icon>title</mat-icon> Excel extracto contable
      </a>
    </li>
    <li (click)="mayorContableCliente(uid)">
      <a>
        <mat-icon>title</mat-icon> Mayor contable cliente
      </a>
    </li>
    <li (click)="mayorContableProveedor(uid)">
      <a>
        <mat-icon>title</mat-icon> Mayor contable proveedor
      </a>
    </li>
    <li (click)="contactBankAccounts(uid)">
      <a>
        <mat-icon>credit_card</mat-icon> Cuentas bancarias
      </a>
    </li>
    <li (click)="listCenters(uid)">
      <a>
        <mat-icon>store</mat-icon> Centros
      </a>
    </li>
    <ng-container *ngIf="showCreateUserOption">
      <li (click)="createUser(uid)">
        <a>
          <mat-icon>person</mat-icon> Crear cuenta Handly
        </a>
      </li>
    </ng-container>

  </ul>
</ng-template>

<ng-container *ngIf="ready === false">
  <div class="container text-center">
    <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
  </div>
</ng-container>